(ns dre.components.searchbar.main-searchbar
  (:require
   [dre.components.searchbar.events :as events]
   [dre.components.searchbar.subs :as subs]
   [dre.components.searchbar.views :refer [searchbar]]
   [dre.page-util :as page-util]
   [dre.pages.search.events :as-alias pages-search]
   [re-frame.core :as rf]))

(defn main-searchbar
  "Main searchbar to be used in platform toolbar and keyword search."
  [{:keys [db-root-path searchbar-ref]} override-opts]
  (let [query (rf/subscribe [::subs/search-query db-root-path])
        filter-query (rf/subscribe [::pages-search/filter-query db-root-path])
        hint (rf/subscribe [::subs/search-input-hint db-root-path])
        suggestions (rf/subscribe [::subs/suggestions db-root-path])
        on-submit #(do (rf/dispatch [::pages-search/submit-query])
                       (when (= :enter %)
                         ;; This will let heap know when query is submitted by pressing the enter key
                         ;; See dre.components.searchbar.views/mock-submit-on-enter-for-heap
                         (.click (js/document.querySelector (->> db-root-path (map name) (apply str) (str "#"))))))
        on-type (page-util/debounce2 #(rf/dispatch-sync [::events/fetch-suggestions db-root-path %]) 125)
        clear-query #(do
                       (rf/dispatch [::events/clear-query db-root-path])
                       (rf/dispatch [::events/clear-counts db-root-path]))
        on-filter-reset #(rf/dispatch [::pages-search/reset-widget-filters])
        on-filter-promote #(rf/dispatch [::pages-search/promote-widget-filters])
        on-undo #(rf/dispatch [::events/undo db-root-path])
        on-redo #(rf/dispatch [::events/redo db-root-path])]
    [searchbar (merge {:db-root-path db-root-path
                       :query query
                       :filter-query filter-query
                       :hint hint
                       :suggestions suggestions
                       :on-submit on-submit
                       :on-type on-type
                       :clear-query clear-query
                       :on-filter-reset on-filter-reset
                       :on-filter-promote on-filter-promote
                       :undo-disabled? (rf/subscribe [::subs/undo-disabled? db-root-path])
                       :redo-disabled? (rf/subscribe [::subs/redo-disabled? db-root-path])
                       :on-undo on-undo
                       :on-redo on-redo
                       :searchbar-ref searchbar-ref}
                      override-opts)]))
